import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { regex } from "../utils/regex";

const initialState = {
  email: "",
  fname: "",
  group_id: "",
  group_name: "",
};
const useSubscribeForm = () => {
  const [userDetails, setUserDetails] = useState(initialState);
  const [showModel, setShowModel] = useState(false);

  useEffect(() => {
    if (!showModel) {
      setUserDetails((prev) => ({ ...prev, group_id: "", group_name: "" }));
    }
  }, [showModel]);

  const handleChange = useCallback((e: any) => {
    const { value, name, id } = e.target;
    setUserDetails((prev) => ({ ...prev, [name]: value, group_id: id }));
  }, []);

  const resetForm = useCallback(() => {
    setUserDetails(initialState);
  }, []);

  const handleSubscribe = useCallback(() => {
    const emailPatter = regex.email;
    if (!userDetails.fname.trim()) {
      return toast.error("Please enter your name!");
    }
    if (!userDetails.email) {
      return toast.error("Please enter your email!");
    }
    if (!userDetails.email.match(emailPatter)) {
      return toast.error("Please enter valid email!");
    }
    setShowModel(true);
  }, [userDetails.email, regex, userDetails.fname]);

  return { userDetails, showModel, handleChange, handleSubscribe, resetForm, setShowModel };
};

export default useSubscribeForm;
